/* tslint:disable */
/* eslint-disable */
/**
 * Workflow service API
 * Service for workflow management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OorResentNotificationRequestDto
 */
export interface OorResentNotificationRequestDto {
    /**
     * Created or processed Workflow instance Id
     * @type {string}
     * @memberof OorResentNotificationRequestDto
     */
    workflowInstanceId: string;
    /**
     * User Id
     * @type {string}
     * @memberof OorResentNotificationRequestDto
     */
    userId?: string;
    /**
     * User's email. Used to define users, send notifications and invite to onboard and take part in the Workflow
     * @type {string}
     * @memberof OorResentNotificationRequestDto
     */
    email?: string;
}

/**
 * Check if a given object implements the OorResentNotificationRequestDto interface.
 */
export function instanceOfOorResentNotificationRequestDto(value: object): boolean {
    if (!('workflowInstanceId' in value)) return false;
    return true;
}

export function OorResentNotificationRequestDtoFromJSON(json: any): OorResentNotificationRequestDto {
    return OorResentNotificationRequestDtoFromJSONTyped(json, false);
}

export function OorResentNotificationRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OorResentNotificationRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'workflowInstanceId': json['workflowInstanceId'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'email': json['email'] == null ? undefined : json['email'],
    };
}

export function OorResentNotificationRequestDtoToJSON(value?: OorResentNotificationRequestDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'workflowInstanceId': value['workflowInstanceId'],
        'userId': value['userId'],
        'email': value['email'],
    };
}

